import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Radio } from 'rmwc/Radio';
import { IntRangeSelect } from '../../components/controls/IntRangeSelect';
import { Button, Typography } from 'rmwc';
import { Text } from '../../components/Text';

import { fetchDashboard } from '../../actions/dashboardActions';
import { fetchPeople } from '../../actions/peopleActions';
import { editSocialSecurityQuiz } from '../../actions/socialSecurityQuizActions';
import { fetchSocialSecurityLifetimeEstimates } from '../../actions/socialSecurityActions';
import { updateTools, nilSingleScore } from '../../actions/toolsActions';

export class SocialSecurityQuiz extends Component {
  constructor(props) {
    super(props);

    this.editLifeExpectancyPrimary = this.editLifeExpectancy.bind(this, 'lifeExpectancyPrimary');
    this.editLifeExpectancyPartner = this.editLifeExpectancy.bind(this, 'lifeExpectancyPartner');
  }

  editLifeExpectancy(field, evt) {
    this.props.editSocialSecurityQuiz(field, evt.target.value);
  }

  componentWillReceiveProps(nextProps) {
    const { dashboard, lifetimeEstimates } = nextProps;
    if (lifetimeEstimates.primary && (!dashboard.has_partner || lifetimeEstimates.partner)) {
      const s_primary = Object.values(lifetimeEstimates.primary.benefits_by_age).sort();
      let dg = s_primary[s_primary.length - 1] - s_primary[s_primary.length - 4];
      if (dashboard.has_parter) {
        const s_partner = Object.values(lifetimeEstimates.partner.benefits_by_age).sort();
        dg += s_partner[s_partner.length - 1] - s_partner[s_partner.length - 4];
      }
      this.props.updateTools({
        active: 'Social Security',
        dollarsGained: dg,
      });
    }
  }

  componentDidMount() {
    this.props.nilSingleScore();
    if (!this.props.dashboard) this.props.fetchDashboard();
    if (!this.props.people) this.props.fetchPeople();
  }

  calculate = () => {
    const { dashboard, editSocialSecurityQuiz, fetchSocialSecurityLifetimeEstimates, socialSecurityQuiz } = this.props;
    fetchSocialSecurityLifetimeEstimates({
      holder: 'primary',
      lifespan: socialSecurityQuiz.lifeExpectancyPrimary,
    });
    if (dashboard.has_partner) {
      fetchSocialSecurityLifetimeEstimates({
        holder: 'partner',
        lifespan: socialSecurityQuiz.lifeExpectancyPartner,
      });
    }
    editSocialSecurityQuiz('questionNumber', socialSecurityQuiz.questionNumber + 1);
  };

  reset = () => {
    const { editSocialSecurityQuiz } = this.props;

    editSocialSecurityQuiz('questionNumber', 0);

    // reset answers
    editSocialSecurityQuiz('needToRelyOnSocialSecurity', undefined);
    editSocialSecurityQuiz('concernedWithSpouseIncomeAfterDeath', undefined);
    editSocialSecurityQuiz('workPartTimeInRetirement', undefined);
    editSocialSecurityQuiz('lifeExpectancyPrimary', undefined);
    editSocialSecurityQuiz('lifeExpectancyPartner', undefined);
  };

  boundSSAge = age => {
    if (age < 62) {
      return 62;
    } else if (age > 70) {
      return 70;
    } else {
      return age;
    }
  };

  getAnswer = () => {
    const {
      needToRelyOnSocialSecurity,
      concernedWithSpouseIncomeAfterDeath,
      workPartTimeInRetirement,
      lifeExpectancyPrimary,
      lifeExpectancyPartner,
    } = this.props.socialSecurityQuiz;
    const { dashboard, lifetimeEstimates } = this.props;

    if (!lifetimeEstimates.primary || (dashboard.has_partner && !lifetimeEstimates.partner)) {
      return { primary: undefined, partner: undefined };
    }

    let optimalAgePrimary = lifetimeEstimates.primary.optimal_age;
    let optimalAgePartner;
    if (dashboard.has_partner) {
      optimalAgePartner = lifetimeEstimates.partner.optimal_age;
    }

    if (needToRelyOnSocialSecurity) {
      optimalAgePrimary -= 5;
      if (dashboard.has_partner) optimalAgePartner -= 5;
    }

    if (concernedWithSpouseIncomeAfterDeath) {
      optimalAgePrimary += 2;
    }

    if (workPartTimeInRetirement) {
      optimalAgePrimary += 2;
      if (dashboard.has_partner) optimalAgePartner += 2;
    }

    // bound social security ages from 62 to 70
    optimalAgePrimary = this.boundSSAge(optimalAgePrimary);
    if (optimalAgePartner) {
      optimalAgePartner = this.boundSSAge(optimalAgePartner);
    }

    return {
      primary: optimalAgePrimary,
      partner: optimalAgePartner,
    };
  };

  getQuestions(currentAnswers) {
    const { editSocialSecurityQuiz } = this.props;

    return [
      {
        type: 'needToRelyOnSocialSecurity',
        title: 'Do you need Social Security to make ends meet?',
        component: (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Text className="pt-4" use="subtitle1">
              Do you need Social Security to make ends meet?
            </Text>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Radio
                value="yes"
                checked={currentAnswers.needToRelyOnSocialSecurity === true}
                onChange={evt => this.props.editSocialSecurityQuiz('needToRelyOnSocialSecurity', true)}
              >
                <Text className="mb-0 mt-1" use="subtitle1">
                  Yes
                </Text>
              </Radio>

              <span className="ml-4">
                <Radio
                  value="no"
                  checked={currentAnswers.needToRelyOnSocialSecurity === false}
                  onChange={evt => this.props.editSocialSecurityQuiz('needToRelyOnSocialSecurity', false)}
                >
                  <Text className="mb-0 mt-1" use="subtitle1">
                    No
                  </Text>
                </Radio>
              </span>
            </div>
            <div className="pt-4">
              <Button
                theme={currentAnswers.needToRelyOnSocialSecurity !== undefined ? 'secondary-bg on-secondary' : null}
                disabled={currentAnswers.needToRelyOnSocialSecurity === undefined}
                onClick={() => this.props.editSocialSecurityQuiz('questionNumber', currentAnswers.questionNumber + 1)}
              >
                Continue
              </Button>
            </div>
          </div>
        ),
      },
      ...(this.props.dashboard.has_partner
        ? [
            {
              type: 'spouseNeedsIncomeAfterDeath',
              title: 'Are you concerned with your spouse having enough income after you die?',
              component: (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Text className="pt-4" use="subtitle1">
                    Are you concerned with your spouse having enough income after you die?
                  </Text>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Radio
                      value="yes"
                      checked={currentAnswers.concernedWithSpouseIncomeAfterDeath === true}
                      onChange={evt => this.props.editSocialSecurityQuiz('concernedWithSpouseIncomeAfterDeath', true)}
                    >
                      <Text className="mb-0 mt-1" use="subtitle1">
                        Yes
                      </Text>
                    </Radio>

                    <span className="ml-4">
                      <Radio
                        value="no"
                        checked={currentAnswers.concernedWithSpouseIncomeAfterDeath === false}
                        onChange={evt =>
                          this.props.editSocialSecurityQuiz('concernedWithSpouseIncomeAfterDeath', false)
                        }
                      >
                        <Text className="mb-0 mt-1" use="subtitle1">
                          No
                        </Text>
                      </Radio>
                    </span>
                  </div>
                  <div className="pt-4">
                    <Button
                      onClick={() =>
                        this.props.editSocialSecurityQuiz('questionNumber', currentAnswers.questionNumber - 1)
                      }
                    >
                      Back
                    </Button>
                    <Button
                      className="ml-2"
                      theme={
                        currentAnswers.concernedWithSpouseIncomeAfterDeath !== undefined
                          ? 'secondary-bg on-secondary'
                          : null
                      }
                      disabled={currentAnswers.concernedWithSpouseIncomeAfterDeath === undefined}
                      onClick={() =>
                        this.props.editSocialSecurityQuiz('questionNumber', currentAnswers.questionNumber + 1)
                      }
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              ),
            },
          ]
        : []),
      {
        type: 'workPartTimeInRetirement',
        title: 'Will you be working part time in retirement?',
        component: (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Text className="pt-4" use="subtitle1">
              Will you be working part-time in retirement?
            </Text>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Radio
                value="yes"
                checked={currentAnswers.workPartTimeInRetirement === true}
                onChange={evt => this.props.editSocialSecurityQuiz('workPartTimeInRetirement', true)}
              >
                <Text className="mb-0 mt-1" use="subtitle1">
                  Yes
                </Text>
              </Radio>

              <span className="ml-4">
                <Radio
                  value="no"
                  checked={currentAnswers.workPartTimeInRetirement === false}
                  onChange={evt => this.props.editSocialSecurityQuiz('workPartTimeInRetirement', false)}
                >
                  <Text className="mb-0 mt-1" use="subtitle1">
                    No
                  </Text>
                </Radio>
              </span>
            </div>
            <div className="pt-4">
              <Button
                onClick={() => this.props.editSocialSecurityQuiz('questionNumber', currentAnswers.questionNumber - 1)}
              >
                Back
              </Button>
              <Button
                className="ml-2"
                theme={currentAnswers.workPartTimeInRetirement !== undefined ? 'secondary-bg on-secondary' : null}
                disabled={currentAnswers.workPartTimeInRetirement === undefined}
                onClick={() => this.props.editSocialSecurityQuiz('questionNumber', currentAnswers.questionNumber + 1)}
              >
                Continue
              </Button>
            </div>
          </div>
        ),
      },
      {
        type: 'lifeExectancy',
        title: 'Until what age do you expect to live?',
        component: (
          <div className="hrbr-form" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Text className="pt-4" use="subtitle1">
              Until what age to you expect to live?
            </Text>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <IntRangeSelect
                style={{ width: '180px' }}
                value={currentAnswers.lifeExpectancyPrimary}
                onChange={this.editLifeExpectancyPrimary}
                label="You"
                spec={this.props.people._default_spec.fields.life_expectancy}
              />
              {this.props.dashboard.has_partner && (
                <IntRangeSelect
                  style={{ width: '180px', marginLeft: '15px' }}
                  value={currentAnswers.lifeExpectancyPartner}
                  onChange={this.editLifeExpectancyPartner}
                  label="Your Spouse"
                  spec={this.props.people._default_spec.fields.life_expectancy}
                />
              )}
            </div>
            <div className="pt-4">
              <Button
                onClick={() => this.props.editSocialSecurityQuiz('questionNumber', currentAnswers.questionNumber - 1)}
              >
                Back
              </Button>
              <Button
                className="ml-2"
                theme={
                  currentAnswers.lifeExpectancyPrimary !== undefined &&
                  (this.props.dashboard.has_partner ? currentAnswers.lifeExpectancyPartner !== undefined : true)
                    ? 'secondary-bg on-secondary'
                    : null
                }
                disabled={
                  currentAnswers.lifeExpectancyPrimary === undefined ||
                  (this.props.dashboard.has_partner ? currentAnswers.lifeExpectancyPartner === undefined : false)
                }
                onClick={this.calculate}
              >
                Calculate
              </Button>
            </div>
          </div>
        ),
      },
      {
        type: 'claimBenefits',
        title: 'Age you should claim benefits:',
        component: (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Text className="pt-4" use="subtitle1">
              Age you should claim benefits:
            </Text>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {this.props.dashboard.has_partner && <Text use="body1">Age you should claim</Text>}
                <Text use="subtitle1">{this.getAnswer().primary}</Text>
              </div>
              {this.props.dashboard.has_partner && (
                <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '15px' }}>
                  <Text use="body1">Age your spouse should claim</Text>
                  <Text use="subtitle1">{this.getAnswer().partner}</Text>
                </div>
              )}
            </div>
            <Button theme="secondary-bg on-secondary" onClick={this.reset}>
              Reset
            </Button>
          </div>
        ),
      },
    ];
  }

  render() {
    const { socialSecurityQuiz } = this.props;

    const question = this.getQuestions(socialSecurityQuiz)[socialSecurityQuiz.questionNumber];

    return <div>{question.component}</div>;
  }
}

function mapStateToProps(state) {
  return {
    dashboard: state.modules.dashboard.data,
    lifetimeEstimates: state.modules.socialSecurity.lifetimeEstimates,
    people: state.people,
    socialSecurityQuiz: state.socialSecurityQuiz,
  };
}

function mapDispatchToProps() {
  return {
    editSocialSecurityQuiz,
    fetchDashboard,
    fetchPeople,
    fetchSocialSecurityLifetimeEstimates,
    updateTools,
    nilSingleScore,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(SocialSecurityQuiz);
